import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import { getDescriptionByTypeId, getLabelByTypeId } from '../../utils/types';
import { eventGenderTypeIds, utrTypeIds } from '../../utils/eventConstants';
import styles from './eventRegForm.scss';

const CampConfirmationCard = ({ division, event, currentRegistration, currencySymbol }) => {
    const auth = useSelector(({ auth }) => auth);
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const {
        genderTypes,
        division: {
            formatTypes,
        },
    } = coreUI.types.tms;

        const nonPowerBasePriceString = division.priceNonPowered;
        const nonPowerBasePrice = parseFloat(nonPowerBasePriceString.replace(/[^0-9.]/g, '')) || 0;
        const nonPowerDivisionPriceToDisplay = nonPowerBasePrice * currentRegistration.quantity;
        const powerBasePriceString = division.price;
        const powerBasePrice = parseFloat(powerBasePriceString.replace(/[^0-9.]/g, '')) || 0;
        const powerDivisionPriceToDisplay = powerBasePrice * currentRegistration.quantity;
        const isSanctioned = event.utrType?.value === 'sanctioned' || event.utrTypeId === utrTypeIds.SANCTIONED;

        const subtitle = useMemo(() => {
            let value;
            const isMixedOrCoedType = division.genderId === eventGenderTypeIds.ALL || division.genderId === eventGenderTypeIds.MIXED;
            const areDivisionAndUserSameGender = getLabelByTypeId(genderTypes, division.genderId)?.toLowerCase() !== auth.user.gender?.toLowerCase();
            if (!isMixedOrCoedType && areDivisionAndUserSameGender) {
                value = `${getDescriptionByTypeId(genderTypes, division.genderId)} Only`;
            }
            return value;
        }, [division, event?.utrTypeId]);

    return (
        <div className={styles.campDivisionSelection}>
            <div className="radio-button radio-button-xl">
                <input id={`division${division.id}`} type="checkbox" />
                <div className={styles.highlight}>
                    <label htmlFor={`division${division.id}`}>
                        <div className="radio-button-label">
                            <div className="d-flex justify-content-between">
                                <div className="flex-1 mw0 text-break mr8">
                                    <div>{division.name}</div>
                                    <div className="fs14 text-black">
                                        {formatTypes.find(type => type.id === parseInt(division.divisionFormatTypeId))?.label}
                                        <span> • </span>
                                        {division.ageRange}
                                        <span> • </span>
                                        {getLabelByTypeId(genderTypes, division.genderId)}
                                    </div>
                                    <div className="radio-button-description fs12 text-bold">{division?.divisionCategoryModel?.label}</div>
                                    {subtitle && <div className="radio-button-description fs12 text-bold">{subtitle}</div>}
                                </div>
                                <div className="d-flex flex-col align-items-center">
                                    <div
                                        className={`${styles.priceText} price text-right fs16 text-bold`}
                                        style={{ textDecoration: auth.user.isPowered && isSanctioned ? 'line-through' : 'none' }}
                                    >
                                        {nonPowerDivisionPriceToDisplay > 0
                                            ? `${currencySymbol}${nonPowerDivisionPriceToDisplay.toFixed(2)}`
                                            : 'Free'}
                                    </div>
                                    {isSanctioned && (
                                    <div
                                        className={`${styles.priceText} price text-right fs12`}
                                    >
                                        {powerDivisionPriceToDisplay > 0
                                            ? `${currencySymbol}${powerDivisionPriceToDisplay.toFixed(2)}/Power`
                                            : 'Free'}
                                    </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    );
};

CampConfirmationCard.propTypes = {
    division: PropTypes.objectOf(any).isRequired,
    event: PropTypes.objectOf(any).isRequired,
    currentRegistration: PropTypes.shape({
        price: PropTypes.number.isRequired,
        quantity: PropTypes.number.isRequired,
    }).isRequired,
    currencySymbol: PropTypes.string.isRequired,
};

CampConfirmationCard.defaultProps = {
};

export default CampConfirmationCard;
